import script from "./sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar.vue?vue&type=script&setup=true&lang=ts"

import "./sidebar.vue?vue&type=style&index=0&id=849413b8&scoped=true&lang=scss"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-849413b8"]])

export default __exports__